import { render, staticRenderFns } from "./realTimeInverter.vue?vue&type=template&id=36ded8df&scoped=true"
import script from "./realTimeInverter.vue?vue&type=script&lang=js"
export * from "./realTimeInverter.vue?vue&type=script&lang=js"
import style0 from "./realTimeInverter.vue?vue&type=style&index=0&id=36ded8df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ded8df",
  null
  
)

export default component.exports